import Vue from 'vue';
import {registerAuth, authUtil} from '@/util/plugins'

/**
 * 1. auth(name) 回傳權限結果
 * 2. 將 name 旗下的 options 與 sessionStorage[login] 進行比對、驗證
 * 
 * 一個 name 只出現在一個 login, 且不重複
 * 
 * login(...).name(...).option({...})
 * 
 */
 const authObj = authUtil
//  cas 登入
  .login('cas')
  // 一般的權限，撇除 P4G
  .name('4g_5gm')
  .option({
    productType: ['4G', '5GM'],
    contractStatus: ['9', '11', '10', '24', '29', '25', '27', '30', '26', '28']
  })
  // 4G, 
  .name('only_4g')
  .option({
    productType: '4G',
    contractStatus: ['9', '11', '10', '24', '29', '25', '27', '30', '26', '28']
  })
  // console.log('authObj: ', authObj);

  const auth = registerAuth(Vue, authObj);



  export default auth;


// WEBPACK FOOTER //
// ./src/auth/auth.js